import { BsPencil } from "react-icons/bs";
import { FaEye } from "react-icons/fa";
import { MdOutlineDeleteForever } from "react-icons/md";
import { useDisclosure } from "@chakra-ui/react";
import { DeleteB2BExpertModal } from "../Modals/DeleteB2BExpertModal";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { NoteB2BExpertModal } from "../Modals/NoteB2BExpertModal";
import { RatingB2BExpertModal } from "../Modals/RatingB2BExpertModal";
import { StarIcon } from "@chakra-ui/icons";
import { employees } from "../../Config/Employees";

export const SingleExpertB2BRow = ({ props, func, id }: any) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const {
    full_name,
    role,
    email,
    rating,
    phone_number,
    address,
    city,
    state,
    country,
    pincode,
    language,
    work_experience,
    prior_manoshala_clients,
    manoshala_spoc,
    worked_with_manoshala,
    price_range,
    note,
  } = props;

  const navigate = useNavigate();
  const [modal, setModal] = useState("");

  return (
    <tr>
      <td>
        <div
          className="edit-icon"
          onClick={() => navigate(`/expertsb2b/edit/${id}`)}
        >
          <BsPencil />
        </div>
      </td>
      <td>
        <div className="d-flex align-items-center">
          <button
            type="button"
            className="btn disabledButton"
            onClick={() => navigate(`/expertsb2b/view/${id}`)}
          >
            <FaEye style={{ color: "#f48a0f" }} />
          </button>
        </div>
      </td>
      <td>{full_name}</td>
      <td>{role}</td>
      {/* <td>{email}</td> */}
      <td>{phone_number}</td>
      {/* <td>{address}</td> */}
      <td>{city}</td>
      <td>
        {worked_with_manoshala === true
          ? "Yes"
          : worked_with_manoshala === false
            ? "No"
            : "Not Added"}
      </td>
      <td>{employees.find((e) => e.value === manoshala_spoc)?.label || "-"}</td>
      <td>{work_experience}</td>
      <td>
        {prior_manoshala_clients?.length ? (
          <ul
            style={{
              listStyle: "none",
              paddingLeft: "16px",
              margin: 0,
            }}
          >
            {prior_manoshala_clients.map((client: any, index: number) => (
              <li key={index}>
                <strong>{client.main_account}</strong>
                {client.client_name && ` — ${client.client_name}`}
              </li>
            ))}
          </ul>
        ) : (
          " "
        )}
      </td>

      {/* <td>{state}</td> */}
      {/* <td>{rating}</td> */}
      <td>
        {rating ? (
          <div>
            {Array.from({ length: Number(rating) }, (_, i) => (
              // <StarIcon key={i} color="yellow.400" boxSize={3} />
              <span key={i} style={{ color: "#FFD700", fontSize: "16px" }}>
                ★
              </span>
            ))}
          </div>
        ) : (
          <div className="d-flex align-items-center">
            <button
              className="btn action-btn pointer"
              onClick={() => {
                setModal("ratingmodal");
                onOpen();
              }}
              type="button"
            >
              Rate
            </button>
          </div>
        )}
      </td>
      <td>{price_range}</td>
      {/* <td>{country}</td> */}
      {/* <td> {pincode} </td> */}
      <td>
        <div className="d-flex align-items-center">
          <button
            className="btn action-btn pointer"
            onClick={() => {
              setModal("notemodal");
              onOpen();
            }}
            type="button"
          >
            Notes
          </button>
        </div>
      </td>
      <td>
        <div className="d-flex align-items-center">
          <span title="Delete">
            <MdOutlineDeleteForever
              className="deleteButton pointer"
              onClick={() => {
                setModal("deletemodal");
                onOpen();
              }}
            />
          </span>
        </div>
      </td>

      {modal === "notemodal" && (
        <NoteB2BExpertModal
          existingNote={note}
          isOpen={isOpen}
          onClose={onClose}
          func={func}
          id={id}
        />
      )}

      {modal === "ratingmodal" && (
        <RatingB2BExpertModal
          existingRating={rating}
          isOpen={isOpen}
          onClose={onClose}
          func={func}
          id={id}
        />
      )}

      {modal === "deletemodal" && (
        <DeleteB2BExpertModal
          isOpen={isOpen}
          onClose={onClose}
          func={func}
          id={id}
        />
      )}
    </tr>
  );
};
